import none from "./none";

export default function(series) {
  return none(series).reverse();
}



//////////////////
// WEBPACK FOOTER
// ./~/recharts/~/d3-shape/src/order/reverse.js
// module id = 3794
// module chunks = 0